var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8982",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9313"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37132",
    d: "M9.225 1.038A12.32 12.32 0 0 0 .386 16.053a12.32 12.32 0 0 0 14.915 9 12.32 12.32 0 0 0 8.839-15.009A12.321 12.321 0 0 0 9.225 1.038",
    transform: "rotate(14 3.73 26.12)",
    style: {
      fill: "#ffec00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37133",
    d: "M9.225 1.038A12.321 12.321 0 0 0 .386 16.053a12.32 12.32 0 0 0 14.915 9 12.32 12.32 0 0 0 8.839-15.009A12.32 12.32 0 0 0 9.225 1.038m5.754 22.747A11.076 11.076 0 0 1 9.547 2.311a11.076 11.076 0 0 1 5.432 21.474",
    transform: "rotate(14 3.73 26.12)",
    style: {
      fill: "#f9c000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37134",
    d: "m38.654 29.386-2.3.584a.934.934 0 0 0-.669 1.138l1.361 5.381c0 .022.008.044.014.067l.915 3.616a.929.929 0 1 0 1.8-.455L39.09 37l1.5-.379.051-.015a3.746 3.746 0 1 0-1.984-7.221m1.443 5.421-1.466.371-.915-3.617 1.4-.355a1.879 1.879 0 0 1 2.481 1.3 1.849 1.849 0 0 1-1.49 2.3",
    transform: "rotate(14 105.71 -73.365)",
    style: {
      fill: "#f9c000"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoint);
export default __webpack_public_path__ + "static/media/icon_point.17a9939514e990f2881fa8723db630ae.svg";
export { ForwardRef as ReactComponent };